/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconChat/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaIconChat({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconChat",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconChat.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-HfFk': alignSelf,'--mt-2-HfFk': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-HfFk': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-HfFk': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-HfFk': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-HfFk': opacity,'--w-10-HfFk': typeof width === 'number' ? `${width}px` : width,'--h-11-HfFk': typeof height === 'number' ? `${height}px` : height,'--a-7-HfFk': isAnimated ? animation : "none",'--sd-8-HfFk': isAnimated ? strokeDashoffset : 0,'--sd-9-HfFk': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconChat.SvgPath"
  data-view-path={viewPath}
 d="M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h8v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"
 style={{'--f-12-HfFk': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}